import _ from "lodash";
import dd from "ES/lib/dd";

require("./EvaluationInput.less");

let component = dd.createClass({
  __onChange: function(e){
    this.props.onChange(e.target.value);
  },
  render(){
    let field = this.props.field;
    let value = this.props.value || "";

    let score_icon = "fa-circle-thin";
    let score_bg = "#F2C411";
    if (parseFloat(value) >= 4.2) {
      score_icon = "fa-circle-thin";
      score_bg = "#57BD8B";
    } else if (parseFloat(value) > 0 && parseFloat(value) < 3.8) {
      score_icon = "fa-circle-thin";
      score_bg = "#FF7878";
    } else if (parseFloat(value) === 0 || _.isNaN(parseFloat(value))) {
      score_bg = "#E8E8E8";
    }

    return dd.div({className: "input-group evaluation-input"},
      dd.input({
        type: "text",
        name: field.name,
        value: value || "",
        disabled: field.disabled ? "disabled" : null,
        className: "form-control",
        onChange: this.__onChange,
        onBlur: this.__onChange
      }),
      dd.div({className: "input-group-addon", style: {backgroundColor: score_bg}}, dd.i({className:`fa ${score_icon}`}, ""))
    );
  }
});

export default {
  component: component,
  validate: function(v){
    return true;
  }
};



// WEBPACK FOOTER //
// ./src/components/inputs/EvaluationInput.js